import React from "react";
import * as yup from "yup";
import {ListEditor} from "../../components/list-editor";
import {
    MediaType,
    MediaTypeQueryQuery,
    useMediaTypeQueryQuery,
    useMediaTypesMutationMutation
} from "../../generated/graphql";
import {useLocation} from "react-router";
import {uniqueId} from "../../utils";

const columns = [{
    header: 'Name',
    accessor: 'label',
    dataType:'text'
}
];

function newRow():MediaType {
    return {
        id: uniqueId(),
        label: ''
    }
}

const schema =  yup.array().of(
        yup.object().shape({
        'label': yup.string().required()
    })
);

function getValues(data:MediaTypeQueryQuery):MediaType[] {
    return data?.mediaTypes?.data??[];
}


function MediaTypes() {
    const query = useMediaTypeQueryQuery();
    const [mutation,mutationResult] = useMediaTypesMutationMutation();
    const url = useLocation().pathname;
    return (
        <ListEditor
            saveResult={mutationResult}
           columns={columns}
           validationSchema={schema}
            title="Media Types"
            mutation={mutation}
            query={query}
            permission="mediatypes"
            newRow={newRow}
            newRowLabel="Add Media Type"
            baseUrl={url}
            getValues={getValues}
            className="media-types"
        />);
}

export default MediaTypes;
